import { render, staticRenderFns } from "./CareGiver3.vue?vue&type=template&id=2fa8fb75&scoped=true&"
import script from "./CareGiver3.vue?vue&type=script&lang=ts&"
export * from "./CareGiver3.vue?vue&type=script&lang=ts&"
import style0 from "./CareGiver3.vue?vue&type=style&index=0&id=2fa8fb75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8fb75",
  null
  
)

export default component.exports